<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" data-cy="certificates-table">
        <v-card outlined v-if="!getCertificates">
          <v-skeleton-loader v-bind="attrs" type="table, table-row"></v-skeleton-loader>
        </v-card>
        <v-snackbar v-model="showSuccess" top right color="#DBEBD2">
          <global-msg-alert
            v-if="successType === 'reinstate'"
            iconColor="#487A7B"
            iconSize="2.5rem"
            icon="fa-circle-check"
            textColor="color: #487A7B"
            type="Success"
            msg="Certificate(s) reinstated successfully"
          ></global-msg-alert>
          <global-msg-alert
            v-if="successType === 'revoke'"
            iconColor="#487A7B"
            iconSize="2.5rem"
            icon="fa-circle-check"
            textColor="color: #487A7B"
            type="Success"
            msg="Certificate(s) revoked successfully"
          ></global-msg-alert>
        </v-snackbar>
        <v-snackbar v-model="showError" top right color="#FCE1D8">
          <global-msg-alert
            iconColor="#9D0E1C"
            iconSize="2.5rem"
            icon="fa-circle-exclamation"
            textColor="color: #9D0E1C"
            type="Error"
            :msg="errorMsg"
          ></global-msg-alert>
        </v-snackbar>
        <v-snackbar v-model="showInfo" top right color="primary">
          <global-msg-alert
            iconColor="#ffff"
            iconSize="2.5rem"
            icon="fa-circle-info"
            textColor="color: #ffff"
            type="Info"
            :msg="infoMsg"
          ></global-msg-alert>
        </v-snackbar>

        <!-- For future implementation? -->
        <!-- <div>
          <v-btn @click="selectedCerts = []">clear certs</v-btn>
          <p>{{ selectedCerts }}</p>
        </div> -->
        <v-card
          elevation="0"
          class="mb-4 table-div"
          v-if="getCertificates?.certificates?.length > 0"
          outlined
        >
          <div class="tool-bar-div">
            <certificates-table-tool-bar
              :selectedCerts="selectedItems"
              :selectedCertsLength="selectedItems.length"
              :itemsFound="getCertificates.searchHits"
              :showErrorTryRevokeRevokedItems="showErrorTryRevokeRevokedItems"
              :showErrorTryReinstateReinstatedItems="showErrorTryReinstateReinstatedItems"
              @reinstateBatch="reinstateItemsClicked"
              @revokeBatch="revokeItemsClicked"
              @revokeItemsClicked="revokeItemsClicked"
              @reinstateItemsClicked="reinstateItemsClicked"
              @columnsChanged="columnsChanged"
              @revokeButton="revokeButton"
              @reinstateButton="reinstateButton"
              ref="certificatesTableToolBar"
            ></certificates-table-tool-bar>
          </div>

          <v-data-table
            checkbox-color="#006CA1"
            v-model="selectedItems"
            show-select
            selected
            @update:options="sortItemsServerSide"
            :loading="loading"
            :headers="headers"
            :items="getCerts"
            :options="{ itemsPerPage: getCertificateSearchParams.searchLimit }"
            class="elevation-0 data-table-div"
            item-key="certid"
            item-class="class"
            hide-default-footer
            data-cy="certificates-table"
            :header-props="{ sortIcon: 'fa-arrow-down-short-wide' }"
            @click:row="singleClick"
            @dblclick:row="doubleClick"
            @contextmenu:row="rightClick"
            id="tableData"
            v-if="getCertificates?.certificates?.length > 0"
          >
            <template #item.certificateserialnumber="{ item, index }">
              <div>
                <v-tooltip right v-model="item.show">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="grey"
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="
                        (show = !show), copyMaterial(item.certificateserialnumber)
                      "
                    >
                      fa-light fa-copy
                    </v-icon>
                  </template>
                  <span> {{ isCopied ? "Copied!" : "Copy" }} </span>
                </v-tooltip>
                <span
                  class="indigo--text accent-4 text-decoration-underline px-2"
                  @click.stop="itemClicked(item)"
                >
                  {{ item.certificateserialnumber }}
                </span>
              </div>
            </template>
            <template #item.totalLifespan="{ item }">
              <div class="d-flex caption">
                <div
                  style="min-width: 50px; border: 1px solid #efefef; border-radius: 5px"
                >
                  <div class="text-center">Years</div>
                  <div class="text-center">{{ item.totalLifespan.years }}</div>
                </div>
                <div class="total-life-span-div">
                  <div class="text-center">Months</div>
                  <div class="text-center">{{ item.totalLifespan.months }}</div>
                </div>
                <div class="total-life-span-div">
                  <div class="text-center">Days</div>
                  <div class="text-center">{{ item.totalLifespan.days }}</div>
                </div>
                <div class="total-life-span-div">
                  <div class="text-center">Hours</div>
                  <div class="text-center">
                    <span style="margin-right: -4px" v-if="item.totalLifespan.hours < 10"
                      >0</span
                    >
                    {{ item.totalLifespan.hours }}:<span
                      style="margin-right: -4px"
                      v-if="item.totalLifespan.minutes < 10"
                      >0</span
                    >
                    {{ item.totalLifespan.minutes }}
                  </div>
                </div>
              </div>
            </template>
            <template #item.lifespan="{ item }">
              <div>
                <v-progress-linear
                  style="border-radius: 10px"
                  :value="item.lifespan"
                  :color="
                    item.lifespan > 25
                      ? '#348d37'
                      : item.lifespan > 0
                      ? '#eb9e00'
                      : item.lifespan === 0
                      ? '#d93529'
                      : 'grey'
                  "
                  height="16"
                  dark
                >
                  <span
                    style="font-size: 12px"
                    :style="item.lifespan < 40 ? 'color:black' : 'color:white'"
                  >
                    {{ item.lifespan }}%
                  </span>
                </v-progress-linear>
              </div>
            </template>
            <template #item.timeToExpire="{ item }">
              <div :style="'color:' + calculateTimeToExpire(item).color">
                {{ calculateTimeToExpire(item).text }}
              </div>
            </template>
            <template #item.status="{ item }">
              <v-icon small class="mr-1" :color="getStatusColor(item)">
                {{ getStatusIcon(item) }}
              </v-icon>
              <span v-if="item.validity === 'expired' && item.status !== 'revoked'">
                {{ item.validity }}
              </span>
              <span v-if="item.validity === 'notYetValid' && item.status !== 'revoked'">
                Not active yet
              </span>
              <span v-else-if="item.validity === 'valid' || item.status === 'revoked'">
                {{ item.status }}</span
              >
              <span v-if="item.reason === 'certificateHold'"> (Hold) </span>
            </template>
            <template #item.actions="{ item, index }">
              <v-menu offset-y v-model="contextMenus[index]">
                <template v-slot:activator="{ attrs, on }">
                  <transition name="bounce" mode="out-in">
                    <i
                      class="fa-regular fa-ellipsis-vertical fa-xl row-action"
                      v-bind="attrs"
                      v-on="on"
                    ></i>
                  </transition>
                </template>
                <div v-if="item">
                  <certificates-table-row-menu
                    :currentItem="item"
                    @itemClicked="itemClicked"
                    @downloadCertificateClicked="downloadCertificateClicked"
                    @revokeButton="revokeButton"
                    @reinstateButton="reinstateButton"
                  ></certificates-table-row-menu>
                </div>
              </v-menu>
            </template>
            <template #item.subjectType="{ item }">
              <div v-if="item.subjectType === 'EE'">
                End Entity
                <v-icon small color="#22304E">fa-regular fa-diagram-project</v-icon>
              </div>
              <div v-if="item.subjectType === 'CA'">
                Certificate Authority
                <v-icon small color="#22304E">fa-regular fa-landmark</v-icon>
              </div>
            </template>
          </v-data-table>
          <v-menu
            v-if="currentItem"
            v-model="rightClickObject.showContext"
            :position-y="rightClickObject.posY"
            :position-x="rightClickObject.posX"
            style="width: 100%"
          >
            <certificates-table-row-menu
              :currentItem="currentItem"
              @itemClicked="itemClicked"
              @downloadCertificateClicked="downloadCertificateClicked"
              @revokeButton="revokeButton"
              @reinstateButton="reinstateButton"
            ></certificates-table-row-menu>
          </v-menu>

          <div class="bottom-border"></div>
          <global-pagination-template>
            <template v-slot:formSlot>
              <v-form ref="form" v-model="goToPageFormValid" lazy-validation>
                <div style="max-width: 100px">
                  <v-text-field
                    hide-details
                    dense
                    outlined
                    label=""
                    min="1"
                    max="goToPageMax"
                    v-model="goToPageModel"
                    :rules="goToPageRules"
                    @keydown.enter.prevent="goToPageClicked()"
                    type="number"
                  />
                </div>
              </v-form>
            </template>
            <template v-slot:pageSlot>
              <v-pagination
                color="#006ca1"
                class="py-5"
                :total-visible="7"
                circle
                v-model="page"
                :length="
                  Math.ceil(
                    getCertificates.searchHits / getCertificateSearchParams.searchLimit
                  )
                "
              >
              </v-pagination>
            </template>
            <template v-slot:limitSlot>
              <div style="max-width: 100px">
                <v-select
                  item-color="#006CA1"
                  color="#006CA1"
                  :items="limitItems"
                  outlined
                  dense
                  v-model="limitModel"
                  @change="limitItemsChanges(limitModel)"
                >
                </v-select>
              </div>
            </template>
          </global-pagination-template>
        </v-card>
        <v-card
          v-if="getCertificates?.certificates?.length === 0"
          elevation="0"
          class="ma-4"
        >
          <v-row justify="center" class="mb-2">
            <div>
              <v-btn x-large fab disabled elevation="0" color="#F9F9F9">
                <i class="fa-light fa-face-clouds fa-2xl" style="color: #767f8d"></i
              ></v-btn>
            </div>
          </v-row>
          <v-row justify="center" class="mb-2">
            <div class="text-h5">No results found</div>
          </v-row>
          <v-row justify="center" class="text-subtitle-1">
            <v-col class="text-center">
              Try adjusting filter criteria in the filter panel above to find what you are
              looking for.
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <global-details-popup :vModel="viewItemDialog" :fullView="fullView">
      <certificates-table-view-dialog
        @closeDialog="closeDialog"
        @changeView="changeView"
        @downloadCertificateClicked="downloadCertificateClicked"
        @updateCurrentCertificate="updateCurrentCertificate"
        @actionResponse="actionResponse"
        :currentCertificate="currentItem"
        :fullView="fullView"
      />
    </global-details-popup>
    <global-details-popup :vModel="revokeDialogue">
      <div class="global-details-popup-div">
        <global-revoke-popup>
          <template v-slot:revokeOptions>
            <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              dense
              :rules="revokeReasonRule"
              :items="constants.REVOCATION_REASONS"
              v-model="revokeReasonModel"
              label="Select a reason"
              data-cy="revoke-reason-select"
              item-text="title"
              item-value="id"
              outlined
              background-color="white"
              clearable
            ></v-select>
          </template>
          <template v-slot:revokeClose>
            <v-btn icon @click="closeRevokeDialogue()" :disabled="revokeButtonLoader">
              <v-icon large>fa-light fa-xmark</v-icon>
            </v-btn>
          </template>
          <template v-slot:revokeClick>
            <v-btn
              plain
              @click="closeRevokeDialogue()"
              class="no-btn"
              :disabled="revokeButtonLoader"
              v-if="!isSubmitting"
              >No</v-btn
            >

            <v-btn
              link
              @click="revokeItemsClicked(revokeReasonModel)"
              :disabled="revokeReasonModel === null"
              class="yes-revoke"
              style="background-color: #9d0e1c; color: #ffffff"
              v-if="!isSubmitting"
              >Yes</v-btn
            >
          </template>
          <template v-slot:pendingRevoke>
            <v-col cols="12" class="orange--text text--darken-2" v-if="isSubmitting">
              <v-icon class="orange--text text--darken-2"
                >fa-light fa-file-signature</v-icon
              >
              Please sign the request using the Personal desktop app.
            </v-col>
            <v-col cols="12" v-if="isSubmitting">
              <v-btn
                elevation="2"
                color="orange"
                class="white--text pr-5 pl-5 pending-sign"
                depressed
                :loading="isSubmitting"
                ><template v-slot:loader
                  ><span>
                    <v-icon color="white" class="ml-1 mr-1 icn-spinner"
                      >fa-light fa-spinner-third</v-icon
                    > </span
                  >Pending signature...</template
                >Pending signature...</v-btn
              >
            </v-col>
          </template>
        </global-revoke-popup>
      </div>
    </global-details-popup>
    <global-details-popup :vModel="reinstateDialogue">
      <div class="global-details-popup-div">
        <global-reinstate-popup @reinstateButton="reinstateButton">
          <template v-slot:reinstateClose>
            <v-btn
              icon
              @click="closeReinstateDialogue()"
              :disabled="reinstateButtonLoader"
            >
              <v-icon large>fa-light fa-xmark</v-icon>
            </v-btn>
          </template>
          <template v-slot:reinstateButton>
            <v-col cols="7" md="5" lg="5" class="text-right" v-if="!isSubmitting">
              <v-btn
                plain
                @click="closeReinstateDialogue()"
                class="no-btn"
                :disabled="reinstateButtonLoader"
                >No</v-btn
              >
              <v-btn
                @click="reinstateItemsClicked()"
                :loading="reinstateButtonLoader"
                class="yes-reinstate"
                style="background-color: #487a7b; color: #ffffff"
                >Yes</v-btn
              >
            </v-col>
          </template>
          <template v-slot:pendingReinstate>
            <v-col cols="12" class="orange--text text--darken-2" v-if="isSubmitting">
              <v-icon class="orange--text text--darken-2"
                >fa-light fa-file-signature</v-icon
              >
              Please sign the request using the Personal desktop app.
            </v-col>
            <v-col cols="12" v-if="isSubmitting">
              <v-btn
                elevation="2"
                color="orange"
                class="white--text pr-5 pl-5 pending-sign"
                depressed
                :loading="isSubmitting"
                ><template v-slot:loader
                  ><span>
                    <v-icon color="white" class="ml-1 mr-1 icn-spinner"
                      >fa-light fa-spinner-third</v-icon
                    ></span
                  >Pending signature...</template
                >Pending signature...</v-btn
              >
            </v-col>
          </template>
        </global-reinstate-popup>
      </div>
    </global-details-popup>
  </div>
</template>

<script>
import CertificatesTableToolBar from "@/components/certificates/certificates-table/certificates-table-tool-bar.vue";
import CertificatesTableViewDialog from "@/components/certificates/certificates-table/view-dialog/certificates-table-view-dialog.vue";
import CertificatesNewFiltersIndex from "@/components/certificates/certificates-filters/certificates-filters-index.vue";
import CertificatesTableRowMenu from "@/components/certificates/certificates-table/certificates-table-row-menu.vue";
import GlobalDetailsPopup from "@/components/global/global-details-popup.vue";
import GlobalMsgAlert from "@/components/global/global-msg-alert.vue";
import GlobalPaginationTemplate from "@/components/global/global-pagination-template.vue";
import { getStatusColor, getStatusIcon } from "@/Mixins/certificates/getStatusMixin.js";
import tableMethods from "@/Mixins/tableMixins";
import { actionResponse } from "@/Mixins/actionResponse";
import { mapActions, mapGetters } from "vuex";
import { ref } from "vue";
import Moment from "moment";
import GlobalRevokePopup from "@/components/global/global-revoke-popup.vue";
import GlobalReinstatePopup from "@/components/global/global-reinstate-popup.vue";
import pgwyClient from "@/api/pgwyClient";
import * as constants from "@/config/constants";
import { CERTIFICATE_HEADERS } from "@/config/certificate-headers";

function watchClass(targetNode, classToWatch) {
  let lastClassState = targetNode.classList.contains(classToWatch);
  const observer = new MutationObserver((mutationsList) => {
    for (let i = 0; i < mutationsList.length; i++) {
      const mutation = mutationsList[i];
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        const currentClassState = mutation.target.classList.contains(classToWatch);
        if (lastClassState !== currentClassState) {
          lastClassState = currentClassState;
          if (!currentClassState) {
            mutation.target.classList.add("sortHandle");
          }
        }
      }
    }
  });
  observer.observe(targetNode, { attributes: true });
}

export default {
  mixins: [getStatusColor, getStatusIcon, tableMethods, actionResponse],
  setup() {
    const certificatesTableToolBar = ref();
    return { certificatesTableToolBar };
  },
  components: {
    CertificatesNewFiltersIndex,
    CertificatesTableViewDialog,
    CertificatesTableToolBar,
    CertificatesTableRowMenu,
    GlobalDetailsPopup,
    GlobalMsgAlert,
    GlobalPaginationTemplate,
    GlobalRevokePopup,
    GlobalReinstatePopup,
  },
  data() {
    return {
      loader: null,
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 0,
      },
      showFilters: false,
      loading: false,
      progressModel: 70,
      revokeReasonModel: null,
      revokeButtonLoader: false,
      reinstateButtonLoader: false,
      revokeDialogue: false,
      reinstateDialogue: false,
      options: {},
      firstTime: true,
      currentItem: null,
      viewItemDialog: false,
      selectedCerts: [],
      isSubmitting: false,
      selectedItems: [],
      showErrorTryRevokeRevokedItems: false,
      showErrorTryReinstateReinstatedItems: false,
      selectedReason: "",
      selectedFormat: "",
      limitItems: [10, 20, 30, 50, 100],
      limitModel: 10,
      goToPageModel: 1,
      goToPageRules: [
        (v) => !!v || "Can't be empty",
        (v) => (v && v > 0) || "Number has to be greater than 0",
        (v) =>
          v <
            Math.ceil(
              this.getCertificates.searchHits /
                this.getCertificateSearchParams.searchLimit
            ) +
              1 || "Number is greater than max page",
      ],
      goToPageFormValid: true,
      revokeReasonRule: [(v) => !!v || "Reason is required"],

      headers: CERTIFICATE_HEADERS.filter((header) => header.defaultVisible),
      errorMsg: "",
      infoMsg: "",
      fullView: false,
      show: false,
      isCopied: false,
      selectedId: 0,
      expanded: [],
      singleExpand: false,
      showSuccess: false,
      showError: false,
      showInfo: false,
      successType: "",
      rightClickObject: {
        showContext: false,
        posY: 0,
        posX: 0,
      },
      contextMenus: {},
    };
  },
  computed: {
    ...mapGetters(["getCertificates", "getCertificateSearchParams", "getOfficerDetails"]),
    constants() {
      return constants;
    },
    getCerts() {
      const certificates = this.getCertificates?.certificates || [];
      certificates.forEach(
        (item) => (item.isSelectable = item.certid !== this.getOfficerDetails?.certid)
      );
      return certificates;
    },
    page: {
      get: function () {
        return this.getCertificateSearchParams.searchOffset;
      },
      set: function (page) {
        this.updateCertificateSearchParams({
          ...this.getCertificateSearchParams,
          searchOffset: page,
        });
      },
    },
  },
  created() {
    this.loading = true;
    this.updateCertificates().finally(() => {
      this.loading = false;
    });
    // const localHeaders = JSON.parse(localStorage.getItem("localHeaders"));
    // if (localHeaders) {
    //   this.headers = localHeaders;
    // }
  },
  mounted() {},
  updated() {
    this.makeHeadersDraggable();
  },
  methods: {
    ...mapActions(["updateCertificateSearchParams", "updateCertificates"]),
    revokeButton(selectRevokeCerts) {
      this.selectedCerts = selectRevokeCerts;
      this.revokeDialogue = true;
    },
    reinstateButton(selectReinstateCerts) {
      this.selectedCerts = selectReinstateCerts;
      this.reinstateDialogue = true;
    },
    closeRevokeDialogue() {
      this.revokeButtonLoader = false;
      this.revokeDialogue = false;
      this.isSubmitting = false;
      this.loading = false;
      this.revokeReasonModel = null;
      this.revokeCont = false;
    },
    closeReinstateDialogue() {
      this.reinstateDialogue = false;
      this.isSubmitting = false;
      this.loading = false;
      this.reinstateCont = false;
    },
    copyMaterial(material) {
      this.isCopied = true;
      navigator.clipboard.writeText(material);
      setTimeout(() => {
        this.isCopied = false;
      }, 700);
    },
    sortItemsServerSide(request) {
      let searchParameters = {
        ...this.getCertificateSearchParams,
        orderBy: "certid",
        orderDescending: false,
      };
      if (request?.sortBy?.length && request?.sortDesc?.length) {
        searchParameters.orderBy = CERTIFICATE_HEADERS.find(
          (header) => header.value === request.sortBy[0]
        ).orderBy;
        searchParameters.orderDescending = request.sortDesc[0];
      }
      this.updateCertificateSearchParams(searchParameters).catch(() => {
        this.showInfo = true;
        this.infoMsg = "Search failed";
      });
    },
    calculateTimeToExpire(item) {
      const time = Moment.duration(Moment().diff(item.timeToExpire)).humanize();
      if (item.timeToExpire > new Date()) {
        if (Math.ceil((item.timeToExpire - new Date()) / (1000 * 60 * 60 * 24)) < 7) {
          return { text: "Expiring in " + time, color: "#c28301" };
        }
        return { text: "Expiring in " + time, color: "black" };
      } else {
        return { text: "Expired " + time + " ago", color: "#bb2216" };
      }
    },
    columnsChanged() {
      this.headers = CERTIFICATE_HEADERS.filter(
        (header) =>
          header.required ||
          this.certificatesTableToolBar.columnsModel.includes(header.shortText)
      );
    },
    async downloadCertificateClicked({ certid, type, extension }) {
      this.closeContextMenus();
      await pgwyClient.downloadCertificates([certid], type, extension);
    },
    async updateCurrentCertificate() {
      await this.updateCertificates();
      this.currentItem = this.getCertificates.certificates.find(
        (cer) => cer.certid === this.currentItem.certid
      );
    },

    revokeItemsClicked(revokeReasonIndex) {
      this.isSubmitting = true;
      let anyError = false;

      this.closeContextMenus();

      if (this.selectedCerts) {
        this.selectedItems = this.selectedCerts;
      }

      this.selectedItems.forEach((selectedCert) => {
        if (
          selectedCert.status === "revoked" &&
          selectedCert.reason !== "certificateHold"
        ) {
          anyError = true;
          selectedCert.class = "item-row-error-background";
          const temp = [...this.selectedItems];
          this.selectedItems = [];
          this.selectedItems = [...temp];
        }
      });
      if (anyError) {
        this.showErrorTryRevokeRevokedItems = true;
        this.showErrorTryReinstateReinstatedItems = false;
        this.isSubmitting = false;
      } else {
        this.showErrorTryRevokeRevokedItems = false;
        const certIds = this.selectedItems.map((item) => item.certid);
        this.loading = true;
        if (certIds.includes(this.getOfficerDetails?.certid)) {
          this.loading = false;
          this.showError = true;
          this.isSubmitting = false;
          this.errorMsg = `Can't revoke the officer certificate ${this.getOfficerDetails?.certserial}`;
          return;
        }
        pgwyClient
          .revokeCertificates(certIds, revokeReasonIndex)
          .then(async () => {
            this.lastClicked = null;
            this.selectedItems = [];
            this.loading = false;
            this.isSubmitting = false;
            this.revokeDialogue = false;
            this.revokeReasonModel = null;
            this.successType = "revoke";
            await this.updateCertificates();
            this.actionResponse({ success: true });
          })
          .catch((err) => {
            this.loading = false;
            this.isSubmitting = false;
            this.actionResponse({
              message: err.response?.data?.msg || "Could not revoke certificate(s)",
            });
          });
      }
    },
    reinstateItemsClicked() {
      let anyError = false;
      this.isSubmitting = true;

      this.closeContextMenus();

      if (this.selectedCerts) {
        this.selectedItems = this.selectedCerts;
      }

      this.selectedItems.forEach((selectedCert) => {
        if (
          selectedCert.status === "active" ||
          (selectedCert.status === "revoked" && selectedCert.reason !== "certificateHold")
        ) {
          anyError = true;
          selectedCert.class = "item-row-error-background";
          const temp = [...this.selectedItems];
          this.selectedItems = [];
          this.selectedItems = [...temp];
        }
      });
      if (anyError) {
        this.showErrorTryReinstateReinstatedItems = true;
        this.showErrorTryRevokeRevokedItems = false;
        this.isSubmitting = false;
      } else {
        this.showErrorTryReinstateReinstatedItems = false;
        const certIds = this.selectedItems.map((item) => item.certid);
        this.loading = true;
        if (certIds.includes(this.getOfficerDetails?.certid)) {
          this.loading = false;
          this.showError = true;
          this.errorMsg = `Can't reinstate the officer certificate ${this.getOfficerDetails?.certserial}`;
          return;
        }
        pgwyClient
          .reinstateCertificates(certIds)
          .then(async () => {
            this.selectedItems = [];
            this.loading = false;
            this.isSubmitting = false;
            this.reinstateDialogue = false;
            this.successType = "reinstate";
            await this.updateCertificates();
            this.actionResponse({ success: true });
          })
          .catch((err) => {
            this.isSubmitting = false;
            this.loading = false;
            this.actionResponse({
              message: err.response?.data?.msg || "Could not reinstate certificate(s)",
            });
          });
      }
    },
    closeContextMenus() {
      this.rightClickObject.showContext = false;
      this.contextMenus = [];
    },
    limitItemsChanges(searchLimit) {
      this.loading = true;
      this.updateCertificateSearchParams({
        ...this.getCertificateSearchParams,
        searchLimit,
      }).finally(() => {
        this.loading = false;
      });
    },
    goToPageClicked() {
      this.goToPageFormValid = this.$refs.form.validate();
      if (this.goToPageFormValid) {
        this.loading = true;
        this.updateCertificateSearchParams({
          ...this.getCertificateSearchParams,
          searchOffset: parseInt(this.goToPageModel),
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/style/main.scss";

::v-deep .v-list-item--link::before {
  background-color: #006ca1;
}
::v-deep .theme--light.v-list-item:hover::before {
  opacity: 0.4;
}

::v-deep .v-data-table-header tr th.sortable-ghost {
  opacity: 0.4;
}

::v-deep .v-data-table-header tr.dragging th.draggable i,
::v-deep .v-data-table-header tr .sortable-drag i {
  display: none;
}

::v-deep .v-data-table tr td:last-child {
  padding: 0 !important;
  text-align: center !important;
  i {
    padding: 20px !important;
  }
}

.global-details-popup-div {
  background-color: #ffffff !important;
}
.total-life-span-div {
  min-width: 50px;
  border: 1px solid #efefef;
  border-radius: 5px;
  margin-left: 5px;
}
.tool-bar-div {
  flex-shrink: 0;
}
.table-div {
  display: flex;
  flex-direction: column;
}
.data-table-div {
  border-top: 1px #d8d8d8 solid;
  border-radius: 0;
}
.v-data-table-header th {
  white-space: nowrap;
}

.row-action:hover {
  text-shadow: black 0px 0px 10px;
}

.pending-sign {
  opacity: 50%;
}

::v-deep .ghostClass {
  background-color: $button-action;
  color: white !important;
}
.bounce-enter-active {
  animation: bounce-in 0.3s ease-out;
}
.bounce-leave-active {
  animation: bounce-out 0.3s ease-out;
}
@keyframes bounce-in {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes bounce-out {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
    opacity: 0;
  }
}

.icn-spinner {
  animation: spin-animation 1s linear infinite;
  display: inline-block;
}

@keyframes spin-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 1264px) {
  ::v-deep
    .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense
    .v-select__selections {
    padding: 4px 0;
    font-size: 0.875rem;
  }

  .v-btn--icon.v-size--default .v-icon,
  .v-btn--fab.v-size--default .v-icon {
    font-size: 24px !important;
  }
}

@media only screen and (max-width: 600px) {
  .three-dots {
    max-width: 7rem !important;
    text-overflow: ellipsis;
  }
}
</style>
